import { useState } from "react";
import { noop } from "lodash";
import { delay } from "lodash";
import type { FilterObject } from "@/react/components/Paywalls/Admin/Filters/DynamicFilters/types";
import { AvailableFiltersList } from "./AvailableFiltersList/AvailableFiltersList";
import { FiltersItems } from "./FiltersItems";

interface DynamicFilterItemsProps {
  customFilters: FilterObject[];
  defaultFilters: FilterObject[];
  getSplitAndAvailableFilters: (filters: FilterObject[]) => {
    displayedFilters: FilterObject[];
    availableFilters: FilterObject[];
  };
  label: string;
  onAddFilter: (name: string) => void;
  onRemoveFilter: (value: string, name: string) => void;
}
export const DynamicFilterItems = ({
  defaultFilters = [],
  customFilters = [],
  onAddFilter = noop,
  onRemoveFilter = noop,
  getSplitAndAvailableFilters,
  label,
}: DynamicFilterItemsProps) => {
  const [newlyAddedFilterName, setNewlyAddedFilterName] = useState<
    string | null
  >(null);

  const { displayedFilters, availableFilters } = getSplitAndAvailableFilters([
    ...defaultFilters,
    ...customFilters,
  ]);
  const hasAvailableFilters = availableFilters.length !== 0;

  const handleAddFilter = (name: string) => {
    /* open the newly added items by default but reset for the next one.
      ensure that default added ones are not opened
    */
    setNewlyAddedFilterName(name);
    delay(() => setNewlyAddedFilterName(null), 500);
    onAddFilter(name);
  };

  return (
    <FiltersItems data-testid="members_filters">
      {displayedFilters.map(
        ({ name, component: Component, isInitialOpen, ...props }: any) => (
          <Component
            key={name}
            name={name}
            onApply={(value: string) => onRemoveFilter(value, name)}
            isInitialOpen={isInitialOpen || newlyAddedFilterName === name}
            shouldShowRemoveButton
            {...props}
          />
        ),
      )}
      {hasAvailableFilters && (
        <AvailableFiltersList
          availableFilters={availableFilters}
          onAddFilter={handleAddFilter}
          defaultFilters={defaultFilters}
          customFilters={customFilters}
          label={label}
        />
      )}
    </FiltersItems>
  );
};
